// hooks
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
// utils
import createAvatar from '../utils/createAvatar';
//
import Avatar from './Avatar';

// ----------------------------------------------------------------------

export default function MyAvatar({ imageUrl, avatarText, ...other }) {
  const currentUser = useSelector((state) => state.auth.currentUser);

  return (
    <Avatar
      src={imageUrl ?? currentUser?.profileImage}
      alt={avatarText ?? currentUser?.fullName}
      color={
        currentUser?.profileImage
          ? 'default'
          : createAvatar(avatarText ?? currentUser?.fullName).color
      }
      {...other}
    >
      {createAvatar(avatarText ?? currentUser?.fullName).name}
    </Avatar>
  );
}

MyAvatar.propTypes = {
  imageUrl: PropTypes.string,
  avatarText: PropTypes.string
};
